module.exports = __webpack_public_path__ + "static/media/skila-bg_img-02-4-nad_600px_width-0_1.6a2ec42e.png";